import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'

import ColorDropdown from 'components/form/colorDropdown'
import Dropdown from 'components/form/dropdown'
import Input from 'components/form/input'

import { 
    aeResourceLevelOptionsSelector, 
    projectHealthOptionsSelector, 
    aeResourceLevelIdSelector,
    projectHealthIdSelector, 
    aeNotesSelector,
    projectWaiverSelector
} from './selectors';

import { updateAeResourceLevelId, updateProjectHealthId, updateAeNotes, updateProjectWaiver } from './actions';

const mapStateToProps = state => {
    return {
      aeResourceLevelOptions: aeResourceLevelOptionsSelector(state),
      projectHealthOptions: projectHealthOptionsSelector(state),
      aeResourceLevelId: aeResourceLevelIdSelector(state),
      projectHealthId: projectHealthIdSelector(state),
      aeNotes: aeNotesSelector(state),
      projectWaiver: projectWaiverSelector(state)
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      updateAeResourceLevelId: (id) => dispatch(updateAeResourceLevelId(id)),
      updateProjectHealthId: (id) => dispatch(updateProjectHealthId(id)),
      updateAeNotes: (notes) => dispatch(updateAeNotes(notes)),
      updateProjectWaiver: (projectWaiver) => dispatch(updateProjectWaiver(projectWaiver))
    }
  }

class AEDetailsEdit extends Component {

  render(){
    const {
    aeResourceLevelOptions,
    projectHealthOptions,
    updateAeResourceLevelId,
    updateProjectHealthId,
    updateAeNotes,
    updateProjectWaiver,
    aeResourceLevelId,
    projectHealthId,
    aeNotes,
    projectWaiver
    } = this.props;

    return (
      <div styleName='ae_details_edit'>
        <Dropdown 
          styleName='user_input'
          title='AE Resource Level' 
          source={aeResourceLevelOptions} 
          value={aeResourceLevelId} 
          onChange={updateAeResourceLevelId}
        />
        <ColorDropdown 
          styleName='user_input'
          title='Project Health' 
          source={projectHealthOptions} 
          value={projectHealthId} 
          onChange={updateProjectHealthId}
        />
        <Input
          styleName='user_input'
          title='AE Notes' 
          type='text'
          value={aeNotes}
          onChange={updateAeNotes}
        />
        <Input
          styleName='user_input'
          title='Project Waiver' 
          type='text'
          value={projectWaiver}
          onChange={updateProjectWaiver}
        />
      </div>
    );
  }
    
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
    withConnect,
    withStyle
)

export default enhance(AEDetailsEdit);